import { PauseIcon, PlayIcon } from '../icons';

type BackgroundToggleProps = {
  isAnimated: boolean;
  onToggle: () => void;
};

export function BackgroundToggle({ isAnimated, onToggle }: BackgroundToggleProps) {
  return (
    <button
      aria-label={isAnimated ? 'Parar animação de fundo' : 'Retomar animação de fundo'}
      aria-pressed={isAnimated}
      className="background-toggle"
      onClick={onToggle}
      type="button"
    >
      <span className="background-toggle-icon">{isAnimated ? <PauseIcon /> : <PlayIcon />}</span>
    </button>
  );
}
